import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import soccer_image from "../../Assets/Images/soccer_image.png";
import soccerBanner from "../../Assets/Images/Soccer/soccer_banner.png";
import soccerSkill1 from "../../Assets/Images/Soccer/soccer_skill1.png";
import soccerSkill2 from "../../Assets/Images/soc1.png";
import soccerSkill3 from "../../Assets/Images/soc2.png";
import soccerSkill4 from "../../Assets/Images/soc3.png";
import soccer2 from "../../Assets/Images/Soccer/soccer1.png";
import soccer3 from "../../Assets/Images/Soccer/soccer3.png";
import soccer4 from "../../Assets/Images/Soccer/soccer4.png";

import soccer1 from "../../Assets/Images/soc.png";
import soccer_trainer1 from "../../Assets/Images/new/t1.png";
import soccer_trainer2 from "../../Assets/Images/new/t2.png";
import soccer_trainer3 from "../../Assets/Images/new/t4.png";
import SoccerBanner1 from "../../Assets/Images/SoccerBanner1.png";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

function Soccer() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  return (
    <>
      <SEO
        title="Instruction | Soccer | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/soccer"
      />
      <div className="soccer-container">
        <div className="soccer-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="soccer-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="soccer-header-content">
              <h1 className="black-text-clip">Soccer</h1>
              <h3 className="black-text-clip">
                Kickstart Your Child's Soccer Journey with BWC Sports!!
              </h3>
              <p className="black-text-clip" style={{ fontWeight: "600" }}>
                Fuel Your Child’s Passion for Soccer with Staten Island’s
                Premier Soccer Program
              </p>
              <p className="black-text-clip" style={{ fontWeight: "500" }}>
                Our skilled basketball trainer offers customized lessons for
                players of all ages and abilities. Whether you’re just starting
                out or looking to sharpen your skills, our sessions focus on
                fundamental techniques, game strategies, and physical
                conditioning. Learn dribbling, shooting, passing, defense, and
                more in a supportive and encouraging environment. Join us to
                enhance your performance, build confidence, and excel on the
                court. Sign up today and start your journey to basketball
                greatness!
              </p>
            </div>
          </div>
        </div>
        <div className="soccer-booking-container">
          <button
            className="one-on-one-soc"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one-soc"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one-soc soccer-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        <div className="soccer-image-container">
          <img src={soccer1} alt="soccer-image" />
          <img src={soccer2} alt="soccer-image" />
          <img src={soccer3} alt="soccer-image" />
          <img src={soccer4} alt="soccer-image" />
        </div>
        <div className="soccer-section2">
          <h3 className="black-text-clip">Why Choose Our Soccer Program?</h3>
          <p className="black-text-clip">
            Soccer isn’t just a game; it’s a path to lifelong skills. We
            combine state-of-the-art training facilities and focused,
            detail-oriented, game-based learning. The result? A program that
            nurtures your child’s love for soccer while building their
            confidence, teamwork, sportsmanship and technical skills.
          </p>
          <div className="soccer-section2-image-container">
            <span className="soccer-overlay-text bottom-left ">
              1-on-1 Training
            </span>
            <span className="soccer-overlay-text top-right soccer-right">
              Group Training
            </span>
            <img src={soccerBanner} alt="soccer-image-session" />
          </div>
        </div>

        <div className="soccer-section3">
          <h3 className="black-text-clip">Dive into Our Exciting Programs</h3>
          <p className="black-text-clip">
            Our programs are packed with a variety of drills and games designed
            to sharpen your skills and boost your confidence:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={soccerSkill1} alt="Ball Control" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Ball Control</div>
                <div className="sc-card-desc">
                  Develop ball control and agility to navigate through
                  defenders. Practice using both feet to maintain possession and
                  create opportunities
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill2} alt="Passing" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Passing</div>
                <div className="sc-card-desc">
                  Focus on accurate and timely passes to teammates. Practice
                  short passes, long balls, and through balls to enhance your
                  ability to distribute the ball effectively on the field.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill3} alt="Shooting" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Shooting</div>
                <div className="sc-card-desc">
                  Work on striking the ball with power and precision. Practice
                  different techniques such as volleys, driven shots, and
                  finesse shots to become a versatile goal scorer.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill4} alt="Defending" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Defending</div>
                <div className="sc-card-desc">
                  Train on positioning, tackling, and intercepting passes to
                  stop opponents. Focus on one-on-one defending, body
                  positioning, and reading the game to anticipate plays.
                </div>
              </div>
            </div>
            {/* <div className="soccer_section_image_cont"><span className="skill-text-overlay">Passing</span><img src={soccerSkill1} alt="Shooting" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Shooting</span><img src={soccerSkill2} alt="Passing" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Defending</span><img src={soccerSkill3} alt="Defense" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Goal Keeping</span><img src={soccerSkill4} alt="Rebounding" /></div> */}
          </div>
        </div>
        <div className="soccer-section4">
          <h3 className="black-text-clip">Scrimmages and Games</h3>
          <p className="black-text-clip">
            Practice makes perfect, but nothing beats game day. Our scrimmages
            and games give players the chance to apply what they’ve learned in a
            real-game setting, building confidence and experience. We cater to
            all skill levels, from ages 4 to 18, ensuring that every player
            finds their place on the field.
          </p>
        </div>
        <div className="soccer-booking-container2">
          <div className="soccer-booking-container-details">
            <h3 className="black-text-clip">READY TO GET STARTED?</h3>
            <p className="black-text-clip">
              Don’t miss out on this incredible opportunity to give your child
              the best start in soccer. Our spots fill up fast—secure your place
              today!
            </p>
            <p className="black-text-clip">
              <strong>Sign Up Now</strong> – Empower your child to succeed on
              and off the court.
            </p>
          </div>
          <div
            id="inside-booking-container"
            className="soccer-booking-container"
          >
            <button
              className="one-on-one"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("1-1")}
            >
              <span className="black-text-clip">
                Schedule 1-on-1 Class Here
              </span>
            </button>
            <button
              className="one-on-one"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("Group")}
            >
              <span className="black-text-clip">Schedule Group Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one soccer-booking-selected"
                style={{ cursor: "pointer" }}
                onClick={() => handleSubmit("")}
              >
                Sign Up for Classes Here
              </button>
            )}
          </div>
        </div>
        <div className="soccer-booking-container outside-booking-container">
          <button
            className="one-on-one"
            style={{ cursor: "pointer" }}
            onClick={() => handleSubmit("1-1")}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            style={{ cursor: "pointer" }}
            onClick={() => handleSubmit("Group")}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one soccer-booking-selected"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("")}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>

        <div className="soccer-trainers">
          <h3 className="black-text-clip">Our Trainers</h3>
          <div className="soccer-trainer-image-container">
            <div className="soccer-trainer-image">
              <div className="skill-text-overlay">
                <h4>Sal Sirico</h4>
                <p>Head Trainer</p>
              </div>
              <img src={soccer_trainer1} alt="trainer-image" />
            </div>
            <div className="soccer-trainer-image">
              <div className="skill-text-overlay">
                <h4>Nico Rivera</h4>
                <p>Head Trainer</p>
              </div>
              <img src={soccer_trainer2} alt="trainer-image" />
            </div>
            <div className="soccer-trainer-image">
              <div className="skill-text-overlay">
                <h4>Eric Wiese</h4>
                <p>Head Trainer</p>
              </div>
              <img src={soccer_trainer3} alt="trainer-image" />
            </div>
          </div>
        </div>
        <div className="soccer-locations">
          <h3 className="black-text-clip text-center">Locations</h3>
          <div className="soccer-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24228.92735189222!2d-74.14155600000001!3d40.61629700000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c3387658829%3A0x770465e3707ce954!2sChurch%20of%20the%20Holy%20Family%2C%20366%20Watchogue%20Rd%2C%20Staten%20Island%2C%20NY%2010314!5e0!3m2!1sen!2sus!4v1773669943931!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Holy Family</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24231.337763431424!2d-74.164119!3d40.60965!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c5bcf5261eb%3A0xea6d9265f869f29d!2s100%20Merrill%20Ave%2C%20Staten%20Island%2C%20NY%2010314!5e0!3m2!1sen!2sus!4v1773670018269!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Moore Catholic High School</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24258.30795685743!2d-74.239816!3d40.535215!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773670049330!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Soccer;
